import { jsxs as t, jsx as s } from "react/jsx-runtime";
import { c as l } from "../../../clsx-OuTLNxxd.js";
import { I as m } from "../../../icon-B72I4fRl.js";
import "../icon/iconsList.js";
const y = "_tag_vkrk5_29", i = {
  tag: y,
  "is-primary-success": "_is-primary-success_vkrk5_43",
  "is-secondary-success": "_is-secondary-success_vkrk5_48",
  "is-primary-info": "_is-primary-info_vkrk5_53",
  "is-secondary-info": "_is-secondary-info_vkrk5_57",
  "is-tertiary-info": "_is-tertiary-info_vkrk5_62",
  "is-primary-warning": "_is-primary-warning_vkrk5_67",
  "is-primary-error": "_is-primary-error_vkrk5_71",
  "is-primary-highlight": "_is-primary-highlight_vkrk5_75",
  "is-secondary-highlight": "_is-secondary-highlight_vkrk5_80",
  "is-collection": "_is-collection_vkrk5_85",
  "is-small": "_is-small_vkrk5_95",
  "is-medium": "_is-medium_vkrk5_99",
  "dialog-overlay-show": "_dialog-overlay-show_vkrk5_1",
  "dialog-content-show": "_dialog-content-show_vkrk5_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_vkrk5_1"
}, g = {
  "primary-success": "is-primary-success",
  "primary-info": "is-primary-info",
  "primary-warning": "is-primary-warning",
  "primary-error": "is-primary-error",
  "primary-highlight": "is-primary-highlight",
  "secondary-success": "is-secondary-success",
  "secondary-info": "is-secondary-info",
  "secondary-highlight": "is-secondary-highlight",
  "tertiary-info": "is-tertiary-info",
  collection: "is-collection"
}, k = {
  small: "is-small",
  medium: "is-medium"
}, h = ({
  text: a,
  size: o = "small",
  color: c = "primary-success",
  className: n = "",
  iconName: r,
  ...e
}) => {
  const _ = l(i.tag, i[g[c]], i[k[o]], n);
  return /* @__PURE__ */ t("div", { className: _, ...e, children: [
    r && /* @__PURE__ */ s(m, { name: r }),
    /* @__PURE__ */ s("p", { children: a })
  ] });
};
h.displayName = "Tag";
export {
  h as Tag
};
